import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { UserCheck, Microscope, Users, HeartHandshake } from 'lucide-react';

const ProgrammeSection = () => {
  const { t } = useLanguage();

  const features = [
    { icon: UserCheck, title: t('programme_feature1') },
    { icon: Microscope, title: t('programme_feature2') },
    { icon: Users, title: t('programme_feature3') },
    { icon: HeartHandshake, title: t('programme_feature4') },
  ];

  return (
    <section
      id="programme"
      className="section-padding bg-white"
      data-testid="programme-section"
    >
      <div className="section-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image Side */}
          <div className="relative order-2 lg:order-1">
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://images.pexels.com/photos/5082949/pexels-photo-5082949.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
                alt="Happy Patient"
                className="w-full h-[400px] lg:h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-teal-900/30 to-transparent"></div>
            </div>
            {/* Floating Card */}
            <div className="absolute -bottom-6 -right-6 bg-white rounded-xl shadow-lg p-4 hidden md:block">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center">
                  <HeartHandshake className="w-6 h-6 text-[#800000]" />
                </div>
                <div>
                  <p className="font-bold text-slate-900">Patient First</p>
                  <p className="text-sm text-slate-500">Philosophy</p>
                </div>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div className="order-1 lg:order-2">
            <span className="text-[#800000] font-semibold text-sm uppercase tracking-wider">
              {t('programme_subtitle')}
            </span>
            <h2
              className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mt-2 mb-6"
              data-testid="programme-title"
            >
              {t('programme_title')}
            </h2>
            <p className="text-base lg:text-lg text-slate-600 mb-8 leading-relaxed">
              {t('programme_description')}
            </p>

            {/* Features Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3 bg-slate-50 rounded-xl p-4 hover:bg-teal-50 transition-colors"
                  data-testid={`programme-feature-${index + 1}`}
                >
                  <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
                    <feature.icon className="w-5 h-5 text-[#800000]" />
                  </div>
                  <p className="font-medium text-slate-800">{feature.title}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProgrammeSection;
